const photoEnhancer = {
  UnlimitedNumberOfSheets: 'Número ilimitado de imágenes',
  SupportAllModels: 'Admite todos los modelos',
  MagnificationAllX: 'Aumento: 1x, 2x, 4x, 8x',
  OutputImageFormatMore: 'Formato de imagen de salida: JPG, PNG, TIFF',
  NoWatermark: 'Sin marca de agua',
  CancelAtAnytime: 'Cancelar en cualquier momento',
  HighPriorityProcessingSpeed: 'Velocidad de procesamiento de alta prioridad',
  HitPawAIPhotoEnhancer: 'HitPaw AI Photo Enhancer',
  weekDayPrice: '1.28€',
  WeekTotalPrice: '8.99€',
  MonthDayPrice: '0.63€',
  MonthTotalPrice: '18.99€',
  YearDayPrice: '0.36€',
  YearTotalPrice: '129.99€',
  Day: 'Día',
  Monthly: 'Mensualmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
};

export default photoEnhancer;
